import webmessenger from "./Webmessenger";

export namespace Messaging {
    export const Webmessenger = webmessenger;
}
